import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';

export type CancelSessionInput = {
  sessionId: string;
  parentId?: string;
  cancelReasonId: string;
  recurring: string;
  fromDatetime: string;
  chargeLate: boolean;
  cancellationNote?: string;
};

export type CancelSessionOutput = {
  status: string;
  error: string;
};

export const cancelSession = (data: CancelSessionInput) => {
  return restClient.request<CancelSessionOutput>('/appointment/session/cancel', { method: 'POST', data: snakecaseKeys(data) });
};
